import { I18nTranslator } from '@strength/i18n';

export const applyMultiWorkoutTemplateOverflowText = (
  t: I18nTranslator,
  templateName: string,
  templateDayCount: number,
  remainingSlotCount: number,
) => ({
  title: t('applyMultiWorkoutTemplateOverflowTitle'),
  message: t('applyMultiWorkoutTemplateOverflowMessage', {
    templateName,
    templateDayCount,
    remainingSlotCount,
  }),
});

export const applyMultiWorkoutTemplateDraftOverwriteText = (
  t: I18nTranslator,
  draftWorkoutCount: number,
) => ({
  title: t('applyMultiWorkoutTemplateDraftOverwriteTitle'),
  message: t('applyMultiWorkoutTemplateDraftOverwriteMessage', {
    draftWorkoutCount,
  }),
});

export const applyMultiWorkoutTemplateActualsText = (
  t: I18nTranslator,
  dayNumbers: number[],
) => ({
  title: t('applyMultiWorkoutTemplateActualsTitle'),
  // one sentence per blocked day, e.g. "Day 2 has logged actuals and can't be overwritten."
  message: dayNumbers
    .map((dayNumber) =>
      t('applyMultiWorkoutTemplateActualsDayMessage', { dayNumber }),
    )
    .join(' '),
});
